module.exports = __webpack_public_path__ + "media/images/athletes/235-5c4f579c9d5d11e374258fd90d02e998.png";